import React from 'react';
import { motion } from 'framer-motion';
import { FaPaintBrush, FaUsers, FaLeaf } from 'react-icons/fa';
import './WhyChooseUs.js';

const iconMap = {
  "تصميمات مبتكرة": <FaPaintBrush size={30} />,
  "خبرة استشارية": <FaUsers size={30} />,
  "الالتزام بالاستدامة": <FaLeaf size={30} />
};

function WhyChooseUs({ items }) {
  return (
    <div className="why-us-container">
      <h2 className="why-us-title">لماذا تختار UN-BORDERS؟</h2>
      <div className="why-us-grid">
        {items.map((item, index) => (
          <motion.div
            key={item.id}
            className="why-us-card"
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: index * 0.2 }}
            whileHover={{ scale: 1.05 }}
          >
            <div className="why-us-icon">
              {iconMap[item.title] || <FaPaintBrush size={30} />}
            </div>
            <h3>{item.title}</h3>
            <p>{item.description}</p>
          </motion.div>
        ))}
      </div>
    </div>
  );
}

export default WhyChooseUs;
